import PropTypes from 'prop-types'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

import useStyles from './styles'

const IconWrapper = ({ children, className }) => {
  const initialClasses = useStyles()

  return <div className={classNames(initialClasses.root, className)}>{children}</div>
}

IconWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
}
IconWrapper.defaultProps = {
  className: '',
}

export default IconWrapper
